module.exports = __webpack_public_path__ + "static/media/94.b58eda34.webp";